import * as React from 'react';
import { SVGProps } from 'react';

const IconCodeSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.571 6a3 3 0 0 1 3-3H9v2H7.571a1 1 0 0 0-1 1v2.355a3 3 0 0 1-1.158 2.368L4 11.823v.355l1.413 1.099a3 3 0 0 1 1.158 2.368V18a1 1 0 0 0 1 1H9v2H7.571a3 3 0 0 1-3-3v-2.355a1 1 0 0 0-.386-.79L2 13.155v-2.31l2.185-1.7a1 1 0 0 0 .386-.79V6ZM16.43 5H15V3h1.429a3 3 0 0 1 3 3v1.866a2 2 0 0 0 .772 1.579l1.799 1.4v2.31l-1.8 1.4a2 2 0 0 0-.771 1.579V18a3 3 0 0 1-3 3H15v-2h1.429a1 1 0 0 0 1-1v-1.866a4 4 0 0 1 1.544-3.158L20 12.178v-.356l-1.027-.798a4 4 0 0 1-1.544-3.158V6a1 1 0 0 0-1-1Zm-.571 2.514-6 10-1.715-1.029 6-10 1.714 1.03Z" />
  </svg>
);
export default IconCodeSizeL;
